import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Col, Modal, Row } from "react-bootstrap";
import { COLOR_GRAY_TEXT } from "../../../../../../constants/Colors";
import LogButton from "../../../../../../components/atoms/LogButton";
import useGoogleMapsApi from "../../../../../../services/useGoogleMapsApi";

const ContentModal = styled.div`
  text-align: left;
`;

const ContentFooterCenter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const ModalLogStyled = styled(Modal)`
opacity: 1;
width: 100%;
.modal-content {
  border-radius: 15px !important;
  padding: 20px;
}
p {
  color: ${COLOR_GRAY_TEXT};
}
`;

const ModalMapView = ({ isModalMapView, onClosePostulation, entity }) => {
  const [isShow, setShowModal] = useState(false);
  const mapRef = useRef();
  const googleMapsApi = useGoogleMapsApi();

  useEffect(() => {
    setShowModal(isModalMapView);
  }, [isModalMapView, entity]);

  const handleLoadGoogleMap = () => {
    let map = mapRef.current;
    const lat = "-38.4192641";
    const lng = "-63.5989206";
    const myLatlng = new googleMapsApi.LatLng(lat.toString(), lng.toString());
    const mapOptions = {
      zoom: 7,
      center: myLatlng,
      scrollwheel: false,
      zoomControl: true,
      mapTypeId: googleMapsApi.MapTypeId.ROADMAP,
      clickableIcons: false,
      disableDefaultUI: true,
    };
    map = new googleMapsApi.Map(map, mapOptions);
    map.addListener("dragend", () => {});
    const directionsService = new googleMapsApi.DirectionsService();
    const directionsRenderer = new googleMapsApi.DirectionsRenderer({
      map: map,
    });

    const origin = new googleMapsApi.LatLng(
      entity.origin_site.latitude.toString(),
      entity.origin_site.longitude.toString()
    );
    const destination = new googleMapsApi.LatLng(
      entity.destiny_site.latitude.toString(),
      entity.destiny_site.longitude.toString()
    );

    directionsService
      .route({
        origin,
        destination,
        travelMode: googleMapsApi.TravelMode.DRIVING,
      })
      .then((result) => {
        directionsRenderer.setDirections(result);
      })
      .catch((e) => {
        window.alert("Directions request failed due to " + e);
      });
  };

  useEffect(() => {
    if (googleMapsApi && isShow) {
      handleLoadGoogleMap();
    }
  }, [googleMapsApi, isShow]);

 

  const handleClose = (payload) => {
    setShowModal(false);
    onClosePostulation();
  };

  return (
    <ModalLogStyled
      show={isShow}
      onHide={handleClose}
      dialogClassName="modal-90w"
      className="modal-dialog-map"
    >
      <Modal.Body>
        <ContentModal>
          <h4 className="font-weight-bold text-primary h5">
            Vista previa de la ruta.
          </h4>
          <hr />
        </ContentModal>
        <Row>
          <Col md="12">
            <div className="map-container">
              <div id="map" ref={mapRef}></div>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <ContentFooterCenter>
          <LogButton
            color="secondary"
            onClick={handleClose}
            title={"Cancelar"}
            border="curve"
            block
          ></LogButton>
        </ContentFooterCenter>
      </Modal.Footer>
    </ModalLogStyled>
  );
};

export default ModalMapView;
